module.exports = __webpack_public_path__ + "static/media/wellesbourne-exterior.79a597ce.jpg";